// extracted by mini-css-extract-plugin
module.exports = {"superElipse":"super-ellipse-skins-small-superElipse-1cf948fc","strokeWidth":"super-ellipse-skins-small-strokeWidth-7af2379b"};